import ResourceCalendar from './components/ResourceCalendar'
import ResourceMap from './components/ResourceMap'
import UnassignedJobs from './components/UnassignedJobs'

const ResourceSchedulingPage = () => {
    return (
        <main className="content">
            <div className="px-container">
                <div className="row gutters-16">
                    <div className="col-12">
                        <ResourceMap />
                    </div>
                    <div className="col-12">
                        <ResourceCalendar />
                    </div>

                    <div className="col-12">
                        <UnassignedJobs />
                    </div>
                </div>
            </div>
        </main>
    )
}

export default ResourceSchedulingPage
